import { format, isValid, parseISO } from 'date-fns';

export const normalizeRelationshipUuid = (value: string): string | null => {
  const compact = value.trim().replace(/-/g, '');
  if (!/^[a-f\d]{32}$/i.test(compact) || !/^(?:[a-f\d]{32}|[a-f\d]{8}-[a-f\d]{4}-[a-f\d]{4}-[a-f\d]{4}-[a-f\d]{12})$/i.test(value.trim())) return null;
  return `${compact.slice(0, 8)}-${compact.slice(8, 12)}-${compact.slice(12, 16)}-${compact.slice(16, 20)}-${compact.slice(20)}`.toLowerCase();
};

const families: Record<string, string> = {
  membership: 'Team membership', access: 'Shared access', communication: 'Messages',
  economy: 'Trading & payments', trade: 'Trading', payment: 'Payments', commerce: 'Purchases',
  session: 'Session timing', place: 'Shared places', movement: 'Travel', social: 'Social commands',
};
export const relationshipLabel = (value: string) => families[value] || value.replace(/[_-]/g, ' ').replace(/^\w/, (letter) => letter.toUpperCase());
/** A calendar day ("2026-09-08") as staff read it. */
export const relationshipDay = (day: string) => {
  const date = parseISO(day);
  return isValid(date) ? format(date, 'd MMM yyyy') : day;
};
export const relationshipTime = (value: string | null | undefined) => {
  if (!value) return 'Unknown';
  const date = parseISO(value);
  return isValid(date) ? format(date, 'd MMM yyyy, HH:mm') : 'Unknown';
};

/** Append a pinned page once, even if a backend returns a boundary record twice. */
export const appendRelationshipPage = <T extends { id: string }>(existing: T[], next: T[]): T[] => {
  const seen = new Set(existing.map((item) => item.id));
  return [...existing, ...next.filter((item) => { if (seen.has(item.id)) return false; seen.add(item.id); return true; })];
};
